export default __webpack_public_path__ + "static/media/0000..0001.4e0d590e.png";